function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

/**
 * Manages scroll position when toggling overflow-hidden class
 * @param {string} action - 'lock' to lock body scroll and save scroll position. Any other value will unlock body scroll and restore scroll position
 * @param {string} [breakpoint] - 'mobile' or 'tablet': The breakpoint for a specific media query class
 */
function handleBodyScrollLock(action, breakpoint = false) {
  const documentBody = document.body;
  const fixedClass = breakpoint ? `body-fixed-${breakpoint}` : 'body-fixed';

  if (action === 'lock') {
    // Get scroll position, set body class to fixed to prevent scrolling
    const scrollY = window.scrollY;
    documentBody.dataset.scrollY = scrollY;
    documentBody.classList.add(fixedClass);
    documentBody.style.top = `-${scrollY}px`;
  } else {
    // Default to unlocking scroll position if action is not 'lock'
    const scrollY = documentBody.dataset.scrollY;
    documentBody.classList.remove(fixedClass);
    documentBody.style.top = '';
    delete documentBody.dataset.scrollY;
    window.scrollTo(0, parseInt(scrollY || '0'));
  }
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll(
      'button:not(.country-selector-opener):not(.header-drawer__close)'
    ).forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement);
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      if (detailsElement.open) {
        detailsElement.classList.remove('menu-opening');
        summaryElement.setAttribute('aria-expanded', false);
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      } else {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }
      !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    handleBodyScrollLock('lock', this.dataset.breakpoint);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    handleBodyScrollLock('unlock', this.dataset.breakpoint);

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.querySelector('.header-drawer__close').addEventListener(
      'click', this.closeBtnClick.bind(this)
    );
  }

  closeBtnClick() {
    this.querySelector('#Details-menu-drawer-container > summary')?.click();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);

    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    handleBodyScrollLock('lock', this.dataset.breakpoint);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    this.closeAllMenuAccordions();
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

    window.removeEventListener('resize', this.onResize);
  }

  openAllMenuAccordions() {
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        const summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }

  closeAllMenuAccordions() {
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        const summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    handleBodyScrollLock('lock');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    // window.pauseAllMedia();
  }

  hide(onCartSubmit = false) {
    // If the modal is closed by the cart submit button, we don't want to unlock the scroll
    if (!onCartSubmit && !document.querySelector('.cart-drawer.is-open')) {
      handleBodyScrollLock('unlock');
    }
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

class FormModalDialog extends ModalDialog {
  constructor() {
    super();
    this.addEventListener('formExit', () => this.hide());

    // Store initial height
    this.initialHeight = null;
    this.modalContent = this.querySelector('.modal__content');

    // Listen for content state changes
    this.addEventListener('content-opened', () => {
      // First set to auto to allow content to expand
      this.modalContent.style.setProperty('--modal-height', 'auto');

      requestAnimationFrame(() => {
        const height = this.modalContent.offsetHeight;
        this.modalContent.style.setProperty('--modal-height', `${height}px`);
      });
    });

    this.addEventListener('content-closed', () => {
      this.modalContent.style.setProperty('--modal-height', 'auto');
    });
  }

  show(opener) {
    super.show(opener);

    // Store the initial height when the modal first opens
    if (!this.initialHeight && this.modalContent) {
      requestAnimationFrame(() => {
        this.initialHeight = this.modalContent.offsetHeight;
        this.modalContent.style.setProperty('--modal-height', `${this.initialHeight}px`);
      });
    }
  }

  hide(onCartSubmit = false) {
    if (this.modalContent) {
      this.modalContent.style.removeProperty('--modal-height');
      this.initialHeight = null;
    }

    this.querySelectorAll('[data-reset-on-modal-close]').forEach(element => {
      if ('reset' in element) element.reset();
    });

    super.hide(onCartSubmit);
  }
}
customElements.define('form-modal-dialog', FormModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener('click', this.loadContent.bind(this));
    } else {
      this.loadContent();
    }
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      //if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

/**
 * A custom element that creates a slider/carousel component with navigation controls.
 * This component handles horizontal scrolling of slides, pagination, and navigation buttons.
 *
 * @extends HTMLElement
 *
 * @fires slideChanged - Dispatched when the current slide changes, contains currentPage and currentElement details
 *
 * @property {HTMLElement} slider - The main slider container element with ID starting with "Slider-"
 * @property {NodeList} sliderItems - Collection of slide elements with IDs starting with "Slide-"
 * @property {boolean} enableSliderLooping - Whether the slider should loop (defaults to false)
 * @property {HTMLElement} currentPageElement - Element displaying current page number
 * @property {HTMLElement} pageTotalElement - Element displaying total pages
 * @property {HTMLElement} prevButton - Previous slide button
 * @property {HTMLElement} nextButton - Next slide button
 */
class SliderComponent extends HTMLElement {
  /**
   * @type {string}
   */
  debugSelector = `.debug`;

  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    // Store initial state
    this._lastWidth = window.innerWidth;
    this._currentIndex = 0;

    this.initPages();
    this.manageDesktopHover();

    // Handle desktop hover behavior for featured image
    if (window.matchMedia('(min-width: 990px)').matches) {
      // Check if we're navigating back and have a stored position
      const navigationEntries = performance.getEntriesByType('navigation');
      const isBackNavigation = navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward';

      if (isBackNavigation) {
        // Try to restore the slider position from sessionStorage
        const storedPositions = JSON.parse(sessionStorage.getItem('sliderPositions') || '{}');
        const sliderId = this.slider.id;
        if (storedPositions[sliderId]) {
          // Set the scroll position after a brief delay to ensure the slider is ready
          setTimeout(() => {
            this.slider.scrollLeft = storedPositions[sliderId];
            this.update();
          }, 100);
        }
      }
    }

    // Modified ResizeObserver to handle responsive transitions
    const resizeObserver = new ResizeObserver(entries => {
      const currentWidth = window.innerWidth;
      const wasDesktop = this._lastWidth >= 990;
      const isDesktop = currentWidth >= 990;

      this._lastWidth = currentWidth;
      this.initPages();

      // Ensure correct position after any resize that recalculates offsets
      if (isDesktop) {
        this.slider.scrollLeft = this.sliderItemOffset || 0;
      } else {
        this.slider.scrollLeft = 0;
      }
    });
    resizeObserver.observe(this.slider);

    // Store slider position before unload
    window.addEventListener('beforeunload', () => {
      const storedPositions = JSON.parse(sessionStorage.getItem('sliderPositions') || '{}');
      storedPositions[this.slider.id] = this.slider.scrollLeft;
      sessionStorage.setItem('sliderPositions', JSON.stringify(storedPositions));
    });

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  /**
   * Allows debug mode for the slider component.
   * If the component instance matches the debugSelector, then debug mode is enabled.
   * Debug mode provides additional logging and debugging information.
   */
  allowDebug() {
    // if the component instance matches the debugSelector, then allow debug.
    // debug selector can be any valid css selector.
    return this.matches(this.debugSelector);
  }

  /**
   * Initializes the slider pages and calculates necessary measurements.
   * This method:
   * 1. Filters visible slider items
   * 2. Calculates offset between items
   * 3. Determines how many slides fit per page
   * 4. Calculates total number of pages
   * 5. Creates pagination indicators for mobile view
   */
  initPages() {
    // Temporarily remove any hover-induced display:none to get true visibility
    const featuredSlides = this.querySelectorAll('.product-card__slide__featured-image');
    const originalDisplayStates = new Map();

    featuredSlides.forEach(slide => {
      originalDisplayStates.set(slide, slide.style.display);
      slide.style.display = ''; // Clear any display:none temporarily
    });

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => {
      // Check if element would be visible without hover effects
      const computedStyle = window.getComputedStyle(element);
      const isHiddenByCSS = computedStyle.display === 'none' && !element.style.display;
      return !isHiddenByCSS;
    });

    // Restore original display states
    featuredSlides.forEach(slide => {
      const originalDisplay = originalDisplayStates.get(slide);
      if (originalDisplay) {
        slide.style.display = originalDisplay;
      } else {
        slide.style.removeProperty('display');
      }
    });

    if (this.sliderItemsToShow.length < 2) {
      this.totalPages = 1;
      return;
    }

    if(this.allowDebug()) {
      console.log('initPages calculation:', {
        itemsToShow: this.sliderItemsToShow.length,
        items: this.sliderItems.length,
        viewportWidth: window.innerWidth
      });
    }

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.createIndicators();
  }

  /**
   * Creates pagination indicator dots for mobile view.
   * Only creates indicators if window width is less than 768px.
   * Adds click handlers to each indicator for direct slide navigation.
   */
  createIndicators() {
    if (window.innerWidth >= 768) return;

    const indicatorContainer = this.querySelector('.slider-indicators');
    if (!indicatorContainer) return;

    indicatorContainer.innerHTML = '';

    this.sliderItemsToShow.forEach((_, i) => {
      const span = document.createElement('span');
      span.classList.add('product-card__gallery-pagination-item');
      span.dataset.index = i;
      span.onclick = () => this.goToSlide(i);
      indicatorContainer.appendChild(span);
    });

    indicatorContainer.firstElementChild?.classList.add('active');
  }

  /**
   * Navigates to a specific slide by index.
   * @param {number} i - The index of the slide to navigate to
   */
  goToSlide(i) {
    this.smoothScrollTo(this.sliderItemsToShow[i].offsetLeft, 800);
    this.updateActiveDot(i);
  }

  /**
   * Updates the active state of pagination dots.
   * @param {number} i - The index of the currently active slide
   */
  updateActiveDot(i) {
    const indicatorContainer = this.querySelector('.slider-indicators');
    if (!indicatorContainer) return;

    indicatorContainer.querySelectorAll('.active').forEach(dot => dot.classList.remove('active'));
    indicatorContainer.children[i]?.classList.add('active');
  }

  /**
   * Sets up desktop hover behavior and handles video playback.
   * Also disables navigation buttons if there's only one page.
   */
  manageDesktopHover() {
    let sliderItems = this.sliderItems;
    this.slider.parentNode.parentNode.addEventListener("mouseover", function(){
      sliderItems.forEach(function(sliderItem){
        if(sliderItem.getAttribute("media_type") == "video"){
          sliderItem.querySelector("video").play();
        }
      });
    });

    if(this.totalPages == 1){
      this.nextButton.setAttribute('disabled', 'disabled');
      this.prevButton.setAttribute('disabled', 'disabled');
    }
  }

  /**
   * Resets the slider pages by re-querying slider items and reinitializing pages.
   */
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  /**
   * Updates the slider state based on current scroll position.
   * Handles:
   * - Current page calculation
   * - Video playback
   * - Page number display
   * - Navigation button states
   * - Lazy loading optimization
   */
  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    const scrollLeft = this.slider.scrollLeft;

    // Try a different approach - calculate the nearest slide based on scroll position
    const slideIndex = Math.round(scrollLeft / this.sliderItemOffset);
    this.currentPage = slideIndex + 1;

    if(this.allowDebug()){
      console.log('SliderComponent update:', {
        previousPage,
        currentPage: this.currentPage,
        scrollLeft,
        sliderItemOffset: this.sliderItemOffset,
        calculatedIndex: slideIndex,
        viewportWidth: window.innerWidth,
        sliderWidth: this.slider.clientWidth
      });
    }

    if(this.sliderItems[this.currentPage-1]?.querySelector("video")){
      this.sliderItems[this.currentPage-1].querySelector("video").play();
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.removeImageLazyLoading()

      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));

      this.updateActiveDot(this.currentPage - 1);
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  /**
   * Checks if a slide element is visible within the slider viewport.
   * @param {HTMLElement} element - The slide element to check
   * @param {number} [offset=0] - Optional offset to adjust visibility check
   * @returns {boolean} Whether the slide is visible
   */
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  /**
   * Handles navigation button clicks.
   * @param {Event} event - The click event object
   */
  onButtonClick(event) {
    event.preventDefault();

    const target = event.currentTarget || event.target;
    const step = target.dataset.step || 1;
    this.slideScrollPosition = target.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);

    const offsetDirection = event.currentTarget.name === 'next' ? 1 : -1;
    const nextSlideIndex = this.currentPage + offsetDirection - 1;
    const nextSlide = this.sliderItems[nextSlideIndex];

    this.sliderItems.forEach(function(sliderItem){
      if(sliderItem.getAttribute("media_type") == "video")
      {
        sliderItem.querySelector("video").play();
      }
    });

    this.removeImageLazyLoading()

    this.smoothScrollTo(this.slideScrollPosition, 800);
  }

  /**
   * Removes lazy loading attributes from images to optimize performance.
   * Handles both mobile and desktop image variants.
   */
  removeImageLazyLoading() {
    let images = null;
    if(window.innerWidth < 550) {
      images = this.querySelectorAll('img.mobile-image[loading="lazy"]')
    } else {
      images = this.querySelectorAll('img.desktop-image[loading="lazy"], img.desktop-main-image[loading="lazy"]')
    }
    if(!images) {
      images = this.querySelectorAll('img[loading="lazy"]')
    }
    images?.forEach((img) => img.removeAttribute('loading'));
  }

  /**
   * Smoothly scrolls the slider to a target position.
   * @param {number} targetScrollLeft - The target scroll position
   * @param {number} [duration=600] - Animation duration in milliseconds
   */
  smoothScrollTo(targetScrollLeft, duration = 600) {
    const start = this.slider.scrollLeft;
    const change = targetScrollLeft - start;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // easeInOutQuad
      const ease = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      this.slider.scrollLeft = start + change * ease;

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateBackInStockVariantId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateBackInStockVariantId() {
    const form = document.querySelector('modal-stock-notify');
    if (!form) return;
    form.querySelector('[name="variant"]').value = this.currentVariant?.id || '';
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const color = this.currentVariant[`option${parseInt(this.dataset.colorOptionIndex) + 1 }`]

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      if (color) {
        const handle = color.replace(/\s+/g, '-').toLowerCase();
        mediaGallery.dispatchEvent(new CustomEvent('colorChanged', {
          detail: {
            color: handle,
          },
        }));
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage();
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections

        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        document.getElementById(`ProductSubmitButton-${sectionId}`)?.classList.remove('loading');

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
          }
        });

        const productInput = this.querySelector('input:checked');

        publish(PUB_SUB_EVENTS.productDynamicUpdate, {
          data: {
            product: productInput?.dataset.productId,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productPreOrder = document.querySelector(`#product-form-${this.dataset.section} [js-property-preorder]`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const modalButtonText = productForm.querySelector('.product__notify-button > .product-form__notify');
    const selectedSize = document.querySelector('input[name="Size"]:checked');
    if(!selectedSize) return;
    if (!addButton) return;

    addButton.classList.remove('unavailable');
    addButton.classList.add('loading');

    // Update button text for Add to Cart
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
      }
      // "Notify Me" modal trigger for sold out products
      if (modalButtonText) {
        modalButtonText.textContent = window.variantStrings.soldOutNotify;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    // Get variant preorder data-attributes
    const datav = selectedSize.dataset.variantmeta;
    const datavc = selectedSize.dataset.variantcheckoutmeta;

    // If we have preorder data, update add to cart buttons and PREORDER line item property
    if(datav !== ""){
      // Update add to cart buttons' messaging if item is not sold out
      if (!addButton.hasAttribute('disabled')) {
        addButtonText.textContent = datav;
        if (modalButtonText) {
          modalButtonText.textContent = datav;
        }
      }
      if (productPreOrder) {
        productPreOrder.setAttribute('name', window.variantStrings.preorderProperty);
        productPreOrder.value = datavc;
      }
    } else {
      // If no preorder data, remove PREORDER line item property
      if (productPreOrder) {
        productPreOrder.removeAttribute('name');
      }
    }

    addButton.classList.remove('not-allowed');
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;
    addButton.classList.add('unavailable');
    addButton.classList.remove('loading');
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


function autoSelectSingleVariantOption(container) {
  if (!container) return;
  
  const fieldsets = container.querySelectorAll('fieldset.product-form__input');
  
  fieldsets.forEach((fieldset) => {
    const legend = fieldset.querySelector('legend');
    const optionName = legend ? legend.textContent.trim().replace(':', '').toLowerCase() : '';
    
    if (optionName === 'color') {
      return;
    }
    
    const radios = fieldset.querySelectorAll('input[type="radio"]');
    
    // If there's only one available option, auto-select it
    if (radios.length === 1) {
      const radio = radios[0];
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  connectedCallback() {
    const colorSwatches = [...this.querySelectorAll('.js-color-change')];

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', this.handleSwatchChange.bind(this));
    });

    requestAnimationFrame(() => {
      autoSelectSingleVariantOption(this);
    });
  }

  handleSwatchChange(e) {
    e.preventDefault();
    if (e.target.classList.contains('is-active')) {
      return;
    }

    publish(PUB_SUB_EVENTS.productDynamicUpdate, {
      data: {
        product: e.currentTarget.dataset.productId,
      },
    });

    const url = e.target.getAttribute('href');
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (!url) {
      return
    }

    fetch(
      `${url}?section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

        const sections = [
          '.js-product-wrapper',
          '[id^="Modal-Shop-The-Look-"]',
          '[id^="ModalStockNotify-"]',
          '[id^="ProductModal-"]',
          '[id^="Modal-size-guide"]',
        ];

        sections.forEach(section => {
          const responseSection = html.querySelector(section);
          const destination = document.querySelector(section);
          const isModalDialog =
            responseSection?.tagName === 'MODAL-DIALOG' ||
            destination?.tagName === 'MODAL-DIALOG';

          if (responseSection && destination) {
            destination.replaceWith(responseSection);
          }

          // Append modal if available
          if (responseSection && !destination && isModalDialog) {
            document.body.appendChild(responseSection);
          }

          // Remove modal if not replaceable
          if (!responseSection && destination && isModalDialog) {
            destination.remove()
          }
        })

        requestAnimationFrame(() => {
          const newVariantRadios = document.querySelector(`#variant-radios-${sectionId}`);
          autoSelectSingleVariantOption(newVariantRadios);
        });

        history.replaceState({}, '', url);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
          },
        });
      });
  };

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets
      .sort((a, b) => {
        const positionA = Number(a.getAttribute('data-option-position'));
        const positionB = Number(b.getAttribute('data-option-position'));
        return positionA > positionB ? 1 : -1;
      })
      .map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        )?.value;
      });
  }
}

customElements.define('variant-radios', VariantRadios);

/**
 * Set cookie.
 * @param {String} name
 * @param {String} value
 * @param {Number} days
 * @returns Void
 */
const setCookie = (name, value, days) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

/**
 * Get cookie data.
 * @param {String} name
 * @returns {String|Null}|
 */
const getCookie = (name) => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
